// extracted by css-extract-rspack-plugin
export default {"sidebarItem":"byWPu","sidebarItemActive":"qMxxr","diffEditor":"lNWeN"};